import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const Kandidatura = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <div className="container max-w-screen-lg pt-3 pb-3 ">
        <h1 className="py-3 text-3xl md:text-5xl font-bold text-[#A81414] ">Постійна формація</h1>
        <div className="text-justify hyphens-auto" id="section5">
          <div className="pt-3 pb-3">
            Після завершення початкової формації брат звертається з проханням бути допущеним до складання вічних обітів у Салезіянському Згромадженні. Цей крок є плодом усвідомленого вибору, що ґрунтується на глибокому самопізнанні та Божій благодаті.
          </div>
          <div className="pt-3 pb-3 font-semibold text-[#A81414]">
            Кандидат до вічних обітів має виявити такі риси:
          </div>
          <ul className="pl-6 list-disc">
            <li className="pt-1 pb-1">
              здатність жити євангельськими радами й дотримуватись обітів;
            </li>
            <li className="pt-1 pb-1">
              глибоке прагнення присвятити все життя служінню Богові у Згромадженні;


            </li>
            <li className="pt-1 pb-1">
              готовність інтегруватися в життя Провінції та здійснювати душпастирське служіння через спільноту;
            </li>
            <li className="pt-1 pb-1">
              моральну певність у своєму покликанні — як брата, диякона чи священика.



            </li>
          </ul>
          <div className="pt-3 pb-3">
            Після складання вічних обітів кожен салезіянин продовжує шлях постійної формації:
          </div>
          <div className="pt-3 pb-3 border-l-4 border-[#A81414] pl-6">
            «За допомогою особистих і спільнотних ініціатив ми плекаємо духовне салезіянське життя, поглиблюємо богословські знання й душпастирські навички, підвищуємо професійну кваліфікацію та зростаємо в апостольській творчості» (Статути, 118).
          </div>
        </div>
      </div>
    </>
  );
};

export default Kandidatura;
